module.exports = __webpack_public_path__ + "img/Fenix.683dea0f.svg";